document.addEventListener('DOMContentLoaded', function () {
  var gate = document.getElementById('AgeGate49Vape');
  if (!gate) return;

  var storageKey = '49vape_age_gate_passed';
  var provinceKey = '49vape_selected_province';

  var enterBtn = document.getElementById('AgeGateEnter');
  var exitBtn = document.getElementById('AgeGateExit');
  var provinceSelect = document.getElementById('AgeGateProvince');
  var errorBox = document.getElementById('AgeGateError');

  function lockSite() {
    gate.classList.add('is-active');
    gate.setAttribute('aria-hidden', 'false');
    document.body.classList.add('age-gate-locked');
  }

  function unlockSite() {
    gate.classList.remove('is-active');
    gate.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('age-gate-locked');
  }

  function showError(message) {
    errorBox.textContent = message;
    errorBox.style.display = 'block';
  }

  function clearError() {
    errorBox.textContent = '';
    errorBox.style.display = 'none';
  }

  try {
    var passed = localStorage.getItem(storageKey);
    var savedProvince = localStorage.getItem(provinceKey);

    if (savedProvince && provinceSelect) {
      provinceSelect.value = savedProvince;
    }

    if (passed === 'true') {
      unlockSite();
      return;
    }
  } catch (e) {
    // continue showing gate if storage is blocked
  }

  lockSite();

  if (enterBtn) {
    enterBtn.addEventListener('click', function () {
      clearError();

      var province = provinceSelect ? provinceSelect.value : '';

      if (!province) {
        showError('Please select a valid province before entering.');
        return;
      }

      try {
        localStorage.setItem(storageKey, 'true');
        localStorage.setItem(provinceKey, province);
      } catch (e) {
        // fallback, still unlock if storage fails
      }

      unlockSite();
    });
  }

  if (exitBtn) {
    exitBtn.addEventListener('click', function () {
      window.location.href = 'https://www.google.com';
    });
  }
});